"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var ApolloProvider_1 = require("./ApolloProvider");
exports.ApolloProvider = ApolloProvider_1.default;
var graphql_1 = require("./graphql");
exports.graphql = graphql_1.default;
exports.withApollo = graphql_1.withApollo;
var redux_1 = require("redux");
exports.compose = redux_1.compose;
__export(require("apollo-client"));
var graphql_tag_1 = require("graphql-tag");
exports.gql = graphql_tag_1.default;
//# sourceMappingURL=browser.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-apollo/lib/browser.js
// module id = 15
// module chunks = 0